<template>
  <div class="checkbox items-center"
       :class="{checked, sm:size==='sm',disabled}"
       @click="$emit('change', !checked)">
    <img :src="icon" alt="" class="tick">
    <label>
      <slot></slot>
    </label>
  </div>
</template>

<script>
import check from '@/assets/icons/check.svg'

export default {
  name: "BaseCheckbox",
  data() {
    return {
      icon: check
    }
  },
  props: {
    checked: {
      type: Boolean,
      required: true
    },
    size: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox {
  @apply flex relative;
  min-height: 2rem;

  &:before {
    @apply absolute w-8 h-8 rounded border border-border left-0 top-0 bg-block;
    content: '';
  }

  .tick {
    @apply absolute inset-2 ;
    opacity: 0;
  }

  label {
    @apply pl-12 text-2sm text-text-secondary;
    cursor: pointer;

    a {
      color: #82868B;
      text-decoration: underline;
    }
  }

  &.checked .tick {
    opacity: 1;
  }

  &.disabled {
    opacity: .6;
    pointer-events: none;
  }

  &.sm {
    min-height: 1.8rem;

    &:before {
      height: 1.8rem;
      width: 1.8rem;
    }

    .tick {
      left: .4rem;
    }

    label {
      padding-left: 2.7rem;
    }
  }
}
</style>
